module.exports = __webpack_public_path__ + "207f6554695f52a0213110f3d3fc2468.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/parnassus.png
// module id = 1715
// module chunks = 0